import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Histories } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-progress-tree',
  templateUrl: './progress-tree.component.html',
  styleUrls: ['./progress-tree.component.scss'],
})
export class ProgressTreeComponent implements OnInit {
  public histories!: Histories[];
  public loading = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId=>{
      const id = enagementId;
      this.loading = true;
      if (id)
        this.homeServiceRef.getHistories(id).subscribe((res) => {
          this.histories = res;
          this.loading = false;
        });
    })
    

  }
}
